import React from 'react'
import { t } from 'ttag'

const ProfileSectionCertificationDetail = ({ section }) => {
  if (!section.additional) {
    return null
  }

  const guessType = d => {
    if (d.typeSkill) {
      return t`Skill`
    }

    if (d.typeProduct) {
      return t`Product / Equipment`
    }

    if (d.typeCore) {
      return t`Core`
    }

    if (d.typeAdvanced) {
      return t`Advanced`
    }

    return null
  }
  const additional = section.additional

  console.log(additional)
  /*
   *renewalThroughCEU" -> d.renewalThroughCEU) ~
   *        ("renewalThroughExam" -> d.renewalThroughExam) ~
   *        ("renewalThroughCPD" -> d.renewalThroughCPD) ~
   *        ("educationTrainingRequired" -> d.educationTrainingRequired) ~
   *        ("workExperienceRequired" -> d.workExperienceRequired) ~
   *        ("examRequired" -> d.examRequired) ~
   *        ("typeProduct" -> d.typeProduct) ~
   *        ("typeCore" -> d.typeCore) ~
   *        ("typeAdvanced" -> d.typeAdvanced) ~
   *        ("typeSpecialty" -> d.typeSpecialty) ~
   *        ("typeSkill" -> d.typeSkill)
   */
  const type = guessType(additional)

  return (
    <table>
      {type ? (
        <tr>
          <td>{t`Type:`}</td>
          <td>{type}</td>
        </tr>
      ) : null}
      <tr>
        <td colSpan="2" style={{ paddingTop: '10px' }}>
          <b>{t`Initial`}</b>
        </td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Exam Required:`}</td>
        <td>{additional.examRequired ? <i className="check"></i> : null}</td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Work Experience Required:`}</td>
        <td>{additional.workExperienceRequired ? <i className="check"></i> : null}</td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Education/Training Required:`}</td>
        <td>{additional.workExperienceRequired ? <i className="check"></i> : null}</td>
      </tr>

      <tr>
        <td colSpan="2" style={{ paddingTop: '10px' }}>
          <b>{t`Renewal`}</b>
        </td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Renewal Required:`}</td>
        <td>
          {additional.renewalRequirement
            ? t`Every ${additional.renewalRequirement} years`
            : null}
        </td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Exam Required:`}</td>
        <td>{additional.examRequired ? <i className="check"></i> : null}</td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Work Experience Required:`}</td>
        <td>{additional.workExperienceRequired ? <i className="check"></i> : null}</td>
      </tr>
      <tr>
        <td style={{ paddingLeft: '5px' }}>{t`Education/Training Required:`}</td>
        <td>{additional.workExperienceRequired ? <i className="check"></i> : null}</td>
      </tr>
      {additional.url ? (
        <tr>
          <td colSpan="2" style={{ paddingTop: '10px' }}>
            <a href={additional.url} className="btn btn-gray btn-full no-style">
              {t`Visit Certification Site`}
            </a>
          </td>
        </tr>
      ) : null}
    </table>
  )
}

export default ProfileSectionCertificationDetail
/*
 *".details" #> (profileDetail match {
 *case Some(d: CertificationProfile) =>
 *    ".ceu" #> <span class={if (d.renewalThroughCEU) "checked" else "unchecked"}></span> &
 *    ".renewexam" #> <span class={if (d.renewalThroughExam) "checked" else "unchecked"}></span> &
 *    ".cpd" #> <span class={if (d.renewalThroughCPD) "checked" else "unchecked"}></span> &
 *    ".edtrain" #> <span class={if (d.educationTrainingRequired) "checked" else "unchecked"}></span> &
 *    ".workexperience" #> <span class={if (d.workExperienceRequired) "checked" else "unchecked"}></span> &
 *    ".exam" #> <span class={if (d.examRequired) "checked" else "unchecked"}></span>
 *
 */
